import { SortOrderItem } from "../../RtSort";
import { AbstractRow } from "../../RtTypes";
/**
 * Инструменты сортировки для случая когда формирование табличных данных выполняется на клиенте
 * (т.е. используется singleLoader)
 */

export const stdCmp = <T>(a: T, b: T): -1 | 0 | 1 => {
  if (a < b) return -1;
  if (b < a) return 1;
  return 0;
};

export type FnCmp<TRow> = (a: TRow, b: TRow) => number;

export type Sorters<TRow> = Record<string, FnCmp<TRow>>;

export const fieldSorter =
  <TRow, Key extends keyof TRow>(
    field: Key,
    cmpFn?: (v1: TRow[Key], v2: TRow[Key]) => number,
  ): FnCmp<TRow> =>
  (row1, row2) =>
    (cmpFn ?? stdCmp)(row1[field], row2[field]);

export const rowsCmp =
  <TRow extends AbstractRow>(order: SortOrderItem[], sorters: Sorters<TRow>) =>
  (row1: TRow, row2: TRow): number => {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of order) {
      let sorter = sorters[item.columnKey];
      if (!sorter && item.columnKey in row1) {
        sorter = fieldSorter(item.columnKey as keyof TRow);
      }
      if (!sorter) continue;
      const res = sorter(row1, row2);
      if (!res) continue;
      return item.mode === "descend" ? -res : res;
    }
    return 0;
  };
